import {type Line} from '../../../util/plotHelpers/types';

/** Summarize input work using array lengths and metadata, never point values. */
export function getUPlotTelemetryContext(
  lines: readonly Line[],
  seriesCount: number
) {
  let sourcePointCount = 0;
  let maxSourcePointCount = 0;
  let hasSmoothing = false;
  let hasGrouping = false;
  let dataMode: Line['meta']['mode'] | 'mixed' = lines[0]?.meta.mode ?? 'mixed';
  for (const line of lines) {
    const length = line.data.length;
    sourcePointCount += length;
    maxSourcePointCount = Math.max(maxSourcePointCount, length);
    hasSmoothing ||=
      line.smoothed === true || line.meta.category === 'smoothed';
    hasGrouping ||=
      line.meta.category === 'grouped' || (line.groupKeys?.length ?? 0) > 0;
    if (line.meta.mode !== dataMode) {
      dataMode = 'mixed';
    }
  }
  const override =
    typeof window === 'undefined'
      ? null
      : new URLSearchParams(window.location.search).get('uPlotMode');
  return {
    uPlotTelemetryVersion: 1,
    renderer: 'uplot' as const,
    modeOverride: override === 'aligned' || override === 'faceted',
    sourcePointCount,
    maxSourcePointCount,
    lineCount: lines.length,
    seriesCount,
    bandCount: seriesCount - lines.length,
    hasSmoothing,
    hasGrouping,
    dataMode,
  };
}
